import logoImg from "../../assets/imgs/logo.png";

export default {
  id: "videobrief",
  appName: "VideoBrief",
  logo: logoImg,

  labels: {
    videos: "Videos",
    myVideos: "My Videos",
    search: "Search videos...",
    content: "videos",
    contentSingular: "video",
    blog: "Blog",
  },

  footer: { owner: "VideoBrief", email: "agent@videobrief.ai", stripped: false },

  theme: {
    accent: "#6847F5",
    headerTextCls: "text-blue-600 dark:text-blue-400",
    searchRingCls: "focus:ring-blue-500",
    quoteIconCls: "text-blue-600 dark:text-blue-400",
    quoteTextCls: "text-blue-400 dark:text-blue-300",
    quoteRingCls: "ring-blue-500",
    quoteBorderCls: "border-blue-500 dark:border-blue-400",
    navActiveCls: "bg-blue-50 text-blue-600 dark:bg-blue-900/40 dark:text-blue-400",
    navActiveDrawerCls: "bg-blue-50 text-blue-600 dark:bg-blue-900/40 dark:text-blue-400 border-r-2 border-blue-500",
    chat: {
      accent: "#6847F5",
      accentShadow: "rgba(104, 71, 245, 0.4)",
      tabActiveBg: "#EDE9FE",
      tabActiveText: "#6847F5",
      tabActiveBorder: "rgba(104, 71, 245, 0.35)",
    },
  },

  features: {
    blog: true,
    payments: true,
    communityDrip: true,
    shareDrip: false,
    quotePortal: true,
    combatTools: false,
    sportsScorebug: false,
    telegramChat: true,
    selfServicePlans: true,
    clippingStudio: true,
  },

  communityDripCuratorId: "687544e286815879896f21ed",

  seoDescription:
    "Turn webinars, demos, interviews, presentations, and events into searchable GTM intelligence and shareable clips.",

  marketing: {
    features: [
      { emoji: "✦", title: "Auto-Condense Entire Video", desc: "One click turns a 60-minute video into a 3-minute condensed cut. Every key moment, stitched together automatically. No editing required." },
      { emoji: "📑", title: "Auto-Chaptered Videos", desc: "AI breaks any video into logical chapters so you can skim content quickly and zero in on highlights." },
      { emoji: "💬", title: "Pull Quotes, Automatically", desc: "AI extracts the most quotable lines from every chapter. Copy them into decks, posts, emails, or follow-ups." },
      { emoji: "✂️", title: "One-Click Clips", desc: "Turn any pull quote into a shareable video clip. Or set your own cue points for precise control." },
      { emoji: "🔍", title: "Searchable Content", desc: "Search across all your videos by keywords, topics, or quotes. Find any moment across your entire content library." },
      { emoji: "🧩", title: "Embeddable Widget", desc: "Create a custom video portal for your chaptered videos that works on any website or landing page." },
      { emoji: "❝", title: "Top Pull Quotes Portal", desc: "A second embeddable portal that surfaces the best pull quotes from your entire library — auto-aggregated or hand-picked." },
      { emoji: "📸", title: "Better Screenshots", desc: "The best way to capture screengrabs. Key for those videos heavy on presentation text and documentation." },
    ],
    personas: [
      { title: "The Busy Executive", tag: "Plow through long videos in minutes.", desc: "Easily find a few nuggets of insight from any recording without sitting through the whole thing." },
      { title: "The Demand Gen Lead", tag: "Turn one recording into 30 days of social growth.", desc: "Extract clips, quotes, and threads from every video — fuel your pipeline without lifting a finger." },
      { title: "The Product Marketer", tag: "Get the key quotes from any competitor video.", desc: "Upload recordings of competitors' videos to easily get the key intelligence you need in seconds." },
      { title: "The Content Strategist", tag: "Repurpose one recording into a month of content.", desc: "Blog posts, social cards, newsletter quotes — all sourced from a single video upload." },
    ],
    hero: {
      title: "Extract Intel. Ship Clips.",
      sub: "Turn long-form video into searchable intelligence, precise clips, and reusable knowledge for your GTM team.",
    },
    loginVisitor: {
      title: "Your GTM Video Library, Working Harder",
      desc: "Find the signal in webinars, demos, interviews, presentations, and events—then ship the exact moment your team needs.",
    },
    chatOpeners: [
      "How can I help? Describe the issue, or attach a screenshot. This sends an email to support.",
    ],
    chatPlaceholder: "Describe your question or bug…",
    chatIntakeOnly: true,
    sections: {
      featuresTitle: "More Insights, Less Time",
      featuresSub: "Upload any video and unlock organized chapters with pull quotes ready to copy, clip, or auto-condense.",
      demoTitle: "See VideoBrief in Action",
      personasTitle: "Works Across Many Use Cases",
      personasSub: "VideoBrief works for anyone buried in replay links.",
      finalCtaTitle: "Ready to auto-condense your next video?",
      finalCtaSub: "Three days and 50,000 tokens for free. Start in under a minute.",
    },
    blogLabel: "Blog",
  },
};
